import * as React from 'react';
import { FormEvent } from 'react';
import { FilterOption } from '../FilterOption';

export type InputType = 'checkbox' | 'radio';

export interface ItemProps<OPTION_TYPE> {
    checked?: boolean,
    label?: string,
    name?: string,
    option: FilterOption<OPTION_TYPE>,
    type: InputType,
    onChange: (event: FormEvent<HTMLInputElement>) => void
}

/**
 * Class for a single Toggle item with it's label (e.g. `<input type="radio"/>` or `<input type="checkbox"/>`
 */
export class Item<OPTION_TYPE> extends React.PureComponent<ItemProps<OPTION_TYPE>> {
    public render() {
        const props = this.props;
        const option = props.option;
        const checked = props.checked || option.checked;
        const type = props.type;
        const isAvailable = option.isAvailable;
        const labelClass = 'pf-label pf-filter-' + type + '-label ' + (checked ? '-active' : '-inactive');
        const className = 'pf-' + type + ' ' + (isAvailable ? '-available' : '-not-available');

        const value = option.value;
        try {
            const inputValue = this.getInputValue(value);

            return <label className={className}>
                <input type={type} checked={checked} name={'' + option.name} value={inputValue}
                       onChange={props.onChange}/>
                <span className={labelClass}>{option.label || props.children}</span>
            </label>;
        } catch (e) {
            return <div className="pf-error">{e.message}</div>;
        }
    }

    private getInputValue(value: string | OPTION_TYPE): string | number {
        if (typeof value === 'string' || typeof value === 'number') {
            return value;
        } else if (typeof value === 'boolean') {
            return value ? 'yes' : 'no';

        } else {
            throw new TypeError(`No rendering definition for option-value type ${typeof value}`);
        }
    }
}
